import { Container, Navbar, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import '../css/admin.css';

export default function AdminLayout({ children }) {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/', { replace: true });
  };

  return (
    <div className="admin-shell">
      <Navbar className="admin-navbar" expand="lg">
        <Container fluid className="admin-navbar-inner">
          <div className="admin-header-block">
            <a
              className="admin-home-link"
              href="/"
              target="_blank"
              rel="noreferrer"
            >
              SAV FOTOGRAFIA
            </a>
          </div>
          <Button
            className="admin-logout-button"
            variant="outline-dark"
            size="sm"
            onClick={handleLogout}
          >
            Cerrar sesion
          </Button>
        </Container>
      </Navbar>
      <Container className="admin-content">{children}</Container>
    </div>
  );
}
